import { render, staticRenderFns } from "./OptimizedSource.vue?vue&type=template&id=6bee5067&lang=pug"
import script from "./OptimizedSource.vue?vue&type=script&lang=ts"
export * from "./OptimizedSource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports